import { isNumber, isString } from './typeof'
import { allProps } from './allProps'
import { compare_version } from './mgtv/version';
import { towebp } from './towebp';

const isPx = /^-?[\d\.]+px$/;
const isCDNImg = /^https:\/\/vipcdn\.mgtv\.com.+\.(jpe?g|png|gif)$/;

export function processComp(obj) {
  //初始化，每个组件增加一个hide属性
  if(!obj.hide){
    obj.hide = false
  }else{
    obj.hide = true
  }
  processCompType(obj);
  checkIsFloat(obj);
  allProps(obj, processFunc, 1, 5);
}

function processCompType(item) {
  switch (item.comp_code) {
    case "NzmVideo":
      loadScript(
        "https://www.mgtv.com/act/2018/mplayer-v2/ZTMobilePlayer.js"
      );
      break;
    // case 'NzmUserInfo':
    //     // item.hide = true
    //     //只在删除了原生用户信息条的版本：iphone：6.5.5，aphone：6.5.9 中展示。
    //     // console.log('version',window.$bus.device_info.appVersion);
    //     if(gact.is_app){
    //       if(gact.is_iphone){
    //         if(compare_version('<','6.5.5')){
    //           item.hide = true
    //         }
    //       }else if(gact.is_android){
    //         if(compare_version('<','6.5.9')){
    //           item.hide = true
    //         }
    //       }
    //     }
    //     break;
    default:
      break;
  }
}

function processFunc(k, v, item) {
  if (isPx.test(v)) {
    item[k] = toRem(v);
  }
}

function checkIsFloat(obj) {
  obj.is_float_comp = ['NzmFloatEntry'].indexOf(obj.comp_code) >= 0 ? true : false;
}

export function toRem(value) {
  if (isString(value)) {
    value = value.replace(/px$/, '');
    value = parseFloat(value);
  }


  if (isNumber(value)) {
    return value / 100 * 2 + 'rem'
  }
  return '0';
}



export function urlToWebp(url) {
  if (!url) {
    return url
  }
  return towebp(url);
}
